module.exports = __webpack_public_path__ + "img/AB9_0472.9a46588b.jpg";